define((require) => {
    "use strict";

    var Backbone              = require("backbone"),
        ExperienceURLProvider = require("ui/experience/ExperienceURLProvider"),
        NavBarView            = require("ui/common/NavBarView"),
        ShareButton           = require("ui/share/ShareButton"),
        template              = require("ui/viewer/PreviewNavBarView.tpl"),
        EditorEvents          = require("shared/services/EditorEvents"),
        ZoomView              = require("ui/editor/ZoomView");

    /**
     * The nav bar view for experience preview.
     *
     * @class PreviewNavBarView
     * @constructor
     *
     * @cfg {ExperienceViewModel} model The experience view model.
     */
    return NavBarView.extend({

        template: template,

        _zoomModel: null,

        className: "nav-bar preview-nav-bar",

        keyboard: {
            escape: function() {
                var experienceURL = ExperienceURLProvider.provide(
                    this.model.get("experienceId"),
                    ExperienceURLProvider.ACTION.EDIT,
                    this.model.get("currentScene")
                );
                Backbone.history.navigate(experienceURL, true);
            }
        },

        bindings: {
            ".return-to-editor": {
                attributes: [{
                    observe: "currentScene",
                    name: "href",
                    onGet: function(sceneNumber) {
                        return "#" + ExperienceURLProvider.provide(
                            this.model.get("experienceId"),
                            ExperienceURLProvider.ACTION.EDIT,
                            sceneNumber,
                            this.model.get("editorCurrentLayer").value
                        );
                    }
                }]
            }
        },

        regions: {
            zoomRegion: ".zoom-region"
        },

        ui: {
            shareButton: ".share-button"
        },

        templateHelpers: function() {
            return {
                variants: this.options.variants,
                currentId: this.model.get("experienceId")
            };
        },

        initialize: function() {
            this._zoomModel = this.options.zoomModel;
        },

        onRender: function() {
            this.zoomRegion.show(new ZoomView({
                zoomModel: this._zoomModel,
                persistZoom: false,
                experienceId: this.model.get("experience").get("id"),
                event: EditorEvents.constants.ZOOM_PREVIEW
            }));

            this.addRegions({"shareButton": ".share-button"});
            this.shareButton.show(new ShareButton({
                experience: this.model.get("experience"),
                offset: {
                    align: "right",
                    elementWidth: 75
                },
                triggerOrigin: "viewer",
                route: null
            }));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/viewer/PreviewNavBarView.js